import {useContext} from "react";
import AuthContext from "context/AuthContext";
import MapRouteCalculatorLeaflet from "./MapRouteCalculatorLeaflet";
import MapRouteCalculatorAzure from "./MapRouteCalculatorAzure";

const MapRouteCalculatorManager = (props) => {
    const {panel} = useContext(AuthContext);
    const provider = props.provider || panel?.map_type || panel?.map_provider || "lf";

    switch (provider) {
        case "az":
            return <MapRouteCalculatorAzure {...props} />;
        case "lf":
        default:
            return <MapRouteCalculatorLeaflet {...props} />;
    }
};

export default MapRouteCalculatorManager;
